<p>
    Monster's Mayhem was commissioned by a client who wanted to rebuild their
    entire flash game in HTML5.
</p>
